import firebase from "firebase/app"
import "firebase/auth"
import 'firebase/firestore';

const app = firebase.initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
})
export const db = firebase.firestore();
export const auth = app.auth()

const googleProvider = new firebase.auth.GoogleAuthProvider()

export const signInWithGoogle = () => {
  
  auth.signInWithPopup(googleProvider).then((res) => {
    console.log('google signin', res.user)
    window.location = "https://algo-tracker-dev.web.app/";

  }).catch((error) => {
    console.log(error.message)
  })
}
export default app
